import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=33896f05&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=33896f05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33896f05",
  null
  
)

export default component.exports